var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulatoryTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#3787FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28 13C30.2091 13 32 14.7909 32 17L32 27C32 29.2091 30.2091 31 28 31L16 31C13.7909 31 12 29.2091 12 27L12 17C12 14.7909 13.7909 13 16 13L28 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19.75C18.7574 19.75 17.75 20.7574 17.75 22C17.75 23.2426 18.7574 24.25 20 24.25C20.3107 24.25 20.6063 24.1873 20.8752 24.0737C20.4805 23.4799 20.25 22.7666 20.25 22C20.25 21.2334 20.4805 20.5201 20.8752 19.9263C20.6063 19.8127 20.3107 19.75 20 19.75ZM22 18.8274C21.4211 18.4619 20.7348 18.25 20 18.25C17.9289 18.25 16.25 19.9289 16.25 22C16.25 24.0711 17.9289 25.75 20 25.75C20.7348 25.75 21.4211 25.5381 22 25.1726C22.5789 25.5381 23.2652 25.75 24 25.75C26.0711 25.75 27.75 24.0711 27.75 22C27.75 19.9289 26.0711 18.25 24 18.25C23.2652 18.25 22.5789 18.4619 22 18.8274ZM24 19.75C23.4233 19.75 22.8988 19.966 22.5002 20.3227C22.0387 20.7358 21.75 21.3337 21.75 22C21.75 22.6663 22.0387 23.2642 22.5002 23.6773C22.8988 24.034 23.4233 24.25 24 24.25C25.2426 24.25 26.25 23.2426 26.25 22C26.25 20.7574 25.2426 19.75 24 19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatoryTools);
export default __webpack_public_path__ + "static/media/regulatory-tools.986389659453a13e3bae447102dcdf80.svg";
export { ForwardRef as ReactComponent };